import { Coins } from "lucide-react";
import { cn } from "@/lib/utils";

interface CreditCostPillProps {
  /** Credit cost to display. A negative value renders as "--" (unresolved). */
  cost: number;
  /** When true, renders "..." instead of the cost (still being fetched). */
  loading?: boolean;
  className?: string;
}

/**
 * Credit-cost token — a coin icon + price wrapped in a subtle pill. Shared by
 * every "create" / "generate" CTA so the cost always reads as one distinct
 * unit, visually set apart from the action label. `tabular-nums` keeps digit
 * width stable so cost changes never nudge the surrounding layout.
 */
export function CreditCostPill({ cost, loading, className }: CreditCostPillProps) {
  return (
    <span
      className={cn(
        "flex items-center gap-1 rounded-full bg-black/20 px-2 py-0.5",
        className,
      )}
    >
      <Coins className="w-3.5 h-3.5 text-amber-300" />
      <span className="text-xs font-bold tabular-nums text-white/90">
        {loading ? "..." : cost < 0 ? "--" : cost}
      </span>
    </span>
  );
}
